import {
  Box,
  Button,
  Flex,
  HStack,
  Input,
  Text,
  useTheme,
  VStack,
} from '@chakra-ui/react'
import { Formik } from 'formik'
import React from 'react'
import Table from '../../../../components/Table/Table'
import UnderlineHeading from '../../../../components/UnderlineText/UnderlineHeading'
import { numberFormat } from '../../../../utils/formats/formats'
import { useLabels } from '../../../../utils/hooks/useLabels/useLabels'
import useShowDetails from '../../hooks/useShowDetails'
import { columns } from '../../temporalData'
import { REPOSITORY } from '../../../../api/repository/Repository'
import { useRefillContext } from '../../../../utils/hooks/Context/RefillContext'
import { useLoadingContext } from '../../../../utils/hooks/Context/LoadingContext'
import { colors } from '../../../../utils/theme/styles'

function Dni() {
  const { texts } = useLabels()
  const {
    colors: { gray },
  } = useTheme()
  const { showDetails, onOpen, boxRef } = useShowDetails()

  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()
  const {
    sucursal,
    cEmpleados,
    centroCosto,
    setCEmpleados,
    handleChangeEmployeeData,
  } = useRefillContext()
  const onSearchEmployee = async (sEmpleado) => {
    const { sEmpresa } = REPOSITORY.local.company.getCompanyData()
    const normalData = {
      page: 1,
      limit: 10,
      enterprice: sEmpresa,
      sEstado: 'AC,EP',
      sSucursal: sucursal,
      sCentroCosto: centroCosto,
    }
    const data = sEmpleado.includes('NN')
      ? { ...normalData, sNombre: sEmpleado.trim() }
      : { ...normalData, sRut: sEmpleado.trim() }
    return REPOSITORY.wsEmpresa.employees.getEmployees(data)
  }
  return (
    <Formik
      initialValues={{
        sEmpleado: '',
        nMonto: '',
      }}
      onSubmit={async (values) => {
        handleOpenLoading()
        setCEmpleados([])

        const employees = await onSearchEmployee(
          values.sEmpleado.replace(/\W+/g, ''),
        ).then((res) => {
          handleCLoseLoading()
          return res.data
        })

        const newData =
          employees.cDatosEmpleados.length > 0
            ? [
                {
                  ...employees.cDatosEmpleados[0],
                  nMonto: values.nMonto.replace(/\W+/g, ''),
                },
              ]
            : []

        setCEmpleados(newData)
        onOpen()
      }}
    >
      {({ values, handleChange, handleSubmit, setFieldValue }) => {
        const isDisabled = !values.nMonto || !values.sEmpleado
        return (
          <Flex direction="column">
            <UnderlineHeading variant="h5">
              {texts.complete_requested_information}
            </UnderlineHeading>
            <Box mt="30px">
              <HStack alignItems="center" spacing="50px">
                <VStack alignItems="flex-start">
                  <Text variant="overline">{texts.enter_collaborator_rut}</Text>
                  <Input
                    name="sEmpleado"
                    id="sEmpleado"
                    onChange={handleChange}
                    value={values?.sEmpleado || ''}
                  />
                  <Text variant="small2" fontWeight={400} color={gray.light}>
                    {texts.only_dni}
                  </Text>
                </VStack>
                <VStack alignItems="flex-start">
                  <Text variant="overline">Ingresa el monto a recargar</Text>
                  <Input
                    name="nMonto"
                    id="nMonto"
                    onFocus={() => {
                      setFieldValue(
                        'nMonto',
                        numberFormat(values.nMonto, 'number'),
                      )
                    }}
                    onBlur={() => {
                      setFieldValue(
                        'nMonto',
                        numberFormat(values.nMonto, 'currency'),
                      )
                    }}
                    onChange={handleChange}
                    value={values.nMonto}
                  />
                  <Text variant="small2" lineHeight="16px" fontWeight="400">
                    Monto a recargar en cuenta del colaborador
                  </Text>
                </VStack>
                <Box pt="20px">
                  <Button
                    onClick={isDisabled ? () => null : handleSubmit}
                    variant={isDisabled ? 'gray' : 'black'}
                  >
                    <Text
                      variant="button13"
                      color={isDisabled ? colors.gray[900] : 'FFFFFF'}
                    >
                      Verificar
                    </Text>
                  </Button>
                </Box>
              </HStack>
            </Box>
            <Box ref={boxRef} mt="34px">
              {showDetails && (
                <VStack spacing="45px" alignItems="flex-start">
                  <UnderlineHeading
                    variant="h5"
                    text={texts.racharge_information}
                  />
                  <Table
                    data={cEmpleados}
                    columns={columns}
                    updateMyData={handleChangeEmployeeData}
                  />
                </VStack>
              )}
            </Box>
          </Flex>
        )
      }}
    </Formik>
  )
}

export default Dni
